import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function Button({
    children,
    variant = 'primary', // primary, secondary, ghost (link)
    className,
    ...props
}) {
    const baseStyles = 'uppercase tracking-widest-xl text-xs transition-colors duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black';

    const variants = {
        primary: 'bg-black text-white hover:bg-gray-800 active:bg-gray-900 py-4 px-8',
        secondary: 'bg-transparent border border-gray-200 text-black hover:bg-black hover:text-white hover:border-black py-3 px-8',
        secondaryDark: 'bg-transparent border border-white/30 text-white hover:bg-white hover:text-black hover:border-white py-3 px-8',
        ghost: 'bg-transparent text-black hover:text-gray-600 underline underline-offset-4 decoration-1 p-0',
    };

    return (
        <button
            className={twMerge(baseStyles, variants[variant], className)}
            {...props}
        >
            {children}
        </button>
    );
}
